import _sfc_main from "./component-library136.mjs";
import "./component-library137.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.InputWrapper, _vm._b({ scopedSlots: _vm._u([{ key: "default", fn: function({ id: wrapperId }) {
    return [_c("select", _vm._b({ staticClass: "input-wrapper__input selectbox", class: _setup.inputOrCustomInputClass, attrs: { "id": wrapperId, "autocomplete": _vm.autocomplete, "aria-invalid": !!_vm.errorMessage, "aria-describedby": `${wrapperId}-error` }, on: { "change": _setup.onInput } }, "select", _setup.inputFieldProps, false), [!_vm.hidePrompt ? _c("option", { domProps: { "selected": _vm.promptValue === _vm.value, "value": _vm.promptValue } }, [_vm._v(" " + _vm._s(_vm.prompt) + " ")]) : _vm._e(), _vm._l(_setup.sanitizedOptions, function(option) {
      return _c("option", { key: option.value, domProps: { "selected": option.value === _vm.value, "value": option.value } }, [_vm._v(" " + _vm._s(option.label) + " ")]);
    })], 2), _c("svg", { staticClass: "selectbox__icon", attrs: { "xmlns": "http://www.w3.org/2000/svg", "aria-hidden": "false", "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "d": "M18.55 8.72a.75.75 0 0 0-1.06-.04L12 13.75 6.51 8.68a.75.75 0 0 0-1.06.04.75.75 0 0 0 .04 1.06L12 15.8l6.51-6a.75.75 0 0 0 .04-1.07", "clip-rule": "evenodd", "fill": "currentColor" } })])];
  } }]) }, "InputWrapper", _setup.inputWrapperProps, false));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ad3eccad",
  null,
  null
);
const SelectInput = __component__.exports;
export {
  SelectInput as default
};
